export var Labels = {
    paymentOptionDivider: 'atau bayar dengan kad kredit'
};
